import React from "react";

const WIDTH = 90;
const HEIGHT = 22;
const PADDING = 2;

/**
 * Schlanke Inline-SVG-Sparkline ohne Bibliothek: eine Linie mit eigener
 * Skala je Zeile, ohne Punkte und Achse - Nachbau der Excel-Spalte
 * "Entwicklungslinie" (Gesamt!J8:J59). `values` besteht bewusst aus den
 * vollen Vorjahren im gewählten Zeitraum plus der Hochrechnung als letztem
 * Punkt, NICHT aus dem angefangenen laufenden Jahr - sonst entstünde
 * derselbe künstliche Einbruch wie im Original (befund.md, Abschnitt
 * "Sparklines").
 */
export default function Sparkline({values, color = "#376092"}) {
    const points = (values || [])
        .filter((value) => value !== null && value !== undefined && !Number.isNaN(Number(value)))
        .map(Number);

    if (points.length < 2) {
        return null;
    }

    const min = Math.min(...points);
    const max = Math.max(...points);
    const range = max - min || 1;

    const stepX = (WIDTH - PADDING * 2) / (points.length - 1);
    const coords = points
        .map((value, index) => {
            const x = PADDING + index * stepX;
            const y = HEIGHT - PADDING - ((value - min) / range) * (HEIGHT - PADDING * 2);
            return `${x.toFixed(1)},${y.toFixed(1)}`;
        })
        .join(" ");

    const label = `Entwicklung der letzten Jahre und Hochrechnung: ${points.map((value) => Math.round(value)).join(" → ")}`;

    return (
        <span aria-label={label}>
            <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} aria-hidden="true" focusable="false">
                <polyline points={coords} fill="none" stroke={color} strokeWidth={1.2} strokeLinejoin="round" strokeLinecap="round" />
            </svg>
        </span>
    );
}
